import { PREVIEW_ACCOUNT_ROWS_SESSION_KEY } from './keys.js'
import { dispatchConnectedToolkitsChanged, readConnectedToolkits } from './sessionToolkits.js'
import { readPreviewAccountRowsFromSession } from './sessionPreviewRows.js'

export function removePreviewAccountRowById(accountId) {
  const id = String(accountId || '').trim()
  if (!id || typeof sessionStorage === 'undefined') return
  try {
    const rows = readPreviewAccountRowsFromSession()
    const next = rows.filter((r) => String(r?.id ?? '') !== id)
    if (next.length === rows.length) return
    sessionStorage.setItem(PREVIEW_ACCOUNT_ROWS_SESSION_KEY, JSON.stringify(next))
    dispatchConnectedToolkitsChanged()
  } catch {
    /* private mode */
  }
}

export function removePreviewAccountRowsForSlug(toolkitSlug) {
  const slug = String(toolkitSlug || '').trim().toLowerCase()
  if (!slug || typeof sessionStorage === 'undefined') return
  try {
    const rows = readPreviewAccountRowsFromSession()
    const next = rows.filter((r) => String(r.toolkitSlug || '').toLowerCase() !== slug)
    if (next.length === rows.length) return
    sessionStorage.setItem(PREVIEW_ACCOUNT_ROWS_SESSION_KEY, JSON.stringify(next))
  } catch {
    /* private mode */
  }
}
